import React from "react";
import styled, { ThemeProvider, useTheme } from "styled-components";
import { useLocation } from "react-router-dom";
import HomeNavigation from "./HomeNavigation";
import Header from "./Header";
import Footer from "./Footer";

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  background: ${(props) => props.theme.ministryPage ? props.theme.colors.homeNavy : "transparent"};
  padding-top: 80px; // Account for fixed header

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding-top: 70px;
  }
`;

const Layout = ({ children }) => {
  const pathname = useLocation().pathname;
  const isHome = pathname === "/books" || pathname === "/" || pathname === "/about" || pathname === "/about/loris-holland";
  const isMinistry = pathname === "/ministries" || pathname.startsWith("/ministries/");
  const theme = useTheme();
  const pageTheme = isHome || isMinistry ? { ...theme, ministryPage: isMinistry, colors: { ...theme.colors, darkBg: theme.colors.homeNavy } } : theme;
  return (
    <ThemeProvider theme={pageTheme}><LayoutWrapper>
      {isHome ? <HomeNavigation activePath={pathname} /> : <Header />}
      <Main>{children}</Main>
      <Footer />
    </LayoutWrapper></ThemeProvider>
  );
};

export default Layout;
